import * as React from 'react';

const PlusSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="plus_svg__eds-icon--plus_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="plus_svg__eds-icon--plus_base"
            d="M11.5 2v9.5H2v1h9.5V22h1v-9.5H22v-1h-9.5V2z"
        />
    </svg>
);

PlusSvg.displayName = 'PlusSvg';
export default PlusSvg;
